import { Component, OnInit, TemplateRef } from '@angular/core';
import { ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ToastrService } from 'ngx-toastr';
import { Router } from "@angular/router";
import { first } from 'rxjs/operators';
import { NavbarService } from '../services/navbar.service';
import { AuthenticationService } from '../services/authentication.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';

@Component({
  selector: 'app-products',
  templateUrl: './products.component.html',
  styleUrls: ['./products.component.scss']
})
export class ProductsComponent implements OnInit {
  addProductCat: FormGroup;
  submitted: boolean = false;
  usersubmitted: boolean = false;
  loginsubmitted: boolean = false;
  invalidLogin: boolean = false;
  showLoader: boolean = true;
  param2;
  data: any = [];
  modalRef: BsModalRef;
  loading: boolean = false;
  response;
  p: number = 1;
  total: number;
  search: string = "";
  constructor(private formBuilder: FormBuilder, private modalService: BsModalService, private toastr: ToastrService, public nav: NavbarService, private authenticationService: AuthenticationService, private router: Router) { }
  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, { backdrop: 'static', keyboard: false });
  }
  get r() { return this.addProductCat.controls; }

  ngOnInit() {

    this.param2 = localStorage.getItem("currentUser");

    if (this.param2 == null) {
      console.log('in null');
      this.router.navigate(['/login']);
    } else {
      this.nav.show();
    }

    this.addProductCat = this.formBuilder.group({
      name: ['', Validators.required],
      description: ['', Validators.required],
      image_url: ['', Validators.required],
    });
    this.getProductlist(1);
  }
  getProductlist(page: number) {
    this.showLoader = true;
    this.authenticationService.getProductlist().subscribe(
      response => {
        this.showLoader = false;
        //if (response['status'] == 200) { 
        if (response['productList'] !== {}) {
          this.data = response['productList'].data;
          this.total = response['productList'].total;
          this.response = response['productList'];
          this.p = page;
          console.log(this.data);

        }
        //}
      }, error => {
        console.log(error);
      });
  }
  deleteProduct(id) {
    if (confirm("Are you sure you want to delete product")) {
      this.authenticationService.deleteProduct(id).subscribe(
        response => {
          //this.getUsers();
          if (response['status'] == 200) {
            console.log('success');
            this.getProductlist(1);
            setTimeout(() => this.toastr.success('Product deleted successfully!'))
          }
        }, error => {
          console.log('errorrrrr');

          setTimeout(() => this.toastr.success('Something went wrong'))
        });
    }
  }
  logout() {
    console.log('inlogout');
    this.nav.hide();
    this.authenticationService.logout();
  }

  addCat() {
    this.submitted = true;
    if (this.addProductCat.invalid) {
      return false;
    }
    var data = this.addProductCat.value;
    //return false;
    var myPostObject = {
      name: data.name,
      description: data.description,
      image_url: data.image_url,
    }
    this.authenticationService.addCategory(myPostObject)
      .pipe(first())
      .subscribe(
        data => {
          //console.log(data);
          //this.saveNotification.reset
          setTimeout(() => this.toastr.success('Category added successfully!'))
          this.addProductCat.reset();
          this.submitted = false;
          this.modalRef.hide()
          this.getProductlist(1);
          //this.router.navigate(['/dashboard']);

        },
        error => {
          setTimeout(() => this.toastr.error('Something went wrong!'))
          //   this.error = error;
          //   this.loading = false;
        });
  }
  getPage(page: number) {
    this.loading = true;
    let url = this.response.first_page_url.split("page=");
    url = url[0] + "&page=" + page;
    this.authenticationService.getalluserspagination(url).subscribe(
      response => {
        if (response['productList'] !== {}) {
          this.data = response['productList'].data;
          this.total = response['productList'].total;
          this.p = page;
          console.log(this.data);

        }
      }, error => {
        console.log(error);
      });
  }

  EditProduct(id) {
    this.router.navigate(['admin/add_product'], { queryParams: { product_id: id } });
  }
  updateFilter() {
    if (this.search.trim() == "") {
      this.getProductlist(1);

    } else {
      this.showLoader = true;
      this.data = [];
      this.total = 0;
      this.p = 0;
      let api = "searchproducts";
      this.authenticationService.searchByQueryString(api, this.search).subscribe(
        response => {
          this.showLoader = false;
          if (response['productList'] !== {}) {
            this.data = response['productList'].data;
            this.total = response['productList'].total;
            this.response = response['productList'];
            this.p = 0;

          }
        }, error => {
          console.log(error);
        });
    }
  }

}
